import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  TArchiveHospitalsRequest,
  THospitalsListRequest,
  THospitalsListResponse,
  THospital,
  THospitalDetailsRequest,
  TDownloadQRCodeRequest,
  TDownloadQRCodeResponse,
  TActivateHospitalsRequest
} from './types'
import { TAddEditHospitalRequest } from '../types'
import {
  ResponseWithPagination,
  TOptionsResponse,
  VALIDATION_MESSAGES
} from '../../../constants'

const fetcher = new Fetcher({})

export const getHospitals = async (
  communityId: string,
  id: string,
  params?: THospitalsListRequest['params']
) =>
  fetcher.request<THospitalsListRequest, THospitalsListResponse>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityId}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/${API_DICTIONARY.HOSPITALS}`,
    method: HTTP_METHODS.GET,
    params
  })

export const archiveHospitals = async (
  communityId: string,
  id: string,
  data: TArchiveHospitalsRequest['data']
) =>
  fetcher.request<TArchiveHospitalsRequest['data'], THospitalsListResponse>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityId}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/${API_DICTIONARY.HOSPITALS}archive/`,
    method: HTTP_METHODS.POST,
    data
  })

export const activateHospitals = async (
  communityId: string,
  id: string,
  data: TActivateHospitalsRequest['data']
) =>
  fetcher.request<TActivateHospitalsRequest['data'], THospitalsListResponse>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityId}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/${API_DICTIONARY.HOSPITALS}activate/`,
    method: HTTP_METHODS.POST,
    data
  })

export const addHospital = async ({
  communityId,
  id,
  data
}: Pick<TAddEditHospitalRequest, 'communityId' | 'id' | 'data'>) =>
  fetcher.request<TAddEditHospitalRequest['data'], THospitalsListResponse>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityId}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/${API_DICTIONARY.HOSPITALS}`,
    method: HTTP_METHODS.POST,
    successMessage: `Hospital ${VALIDATION_MESSAGES.SM0009} added.`,
    data
  })

export const editHospital = async ({
  communityId,
  id,
  hospitalId,
  data
}: TAddEditHospitalRequest & { hospitalId: string }) =>
  fetcher.request<TAddEditHospitalRequest['data'], THospitalsListResponse>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityId}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/${API_DICTIONARY.HOSPITALS}${hospitalId}/`,
    method: HTTP_METHODS.PUT,
    successMessage: `Hospital ${VALIDATION_MESSAGES.SM0009} saved.`,
    data
  })

export const getHospitalData = async (
  communityId: string,
  hsId: string,
  hospitalId: string
) =>
  fetcher.request<THospitalDetailsRequest, THospital>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityId}/${API_DICTIONARY.HEALTH_SYSTEMS}${hsId}/${API_DICTIONARY.HOSPITALS}${hospitalId}/`,
    method: HTTP_METHODS.GET
  })

export const getHealthSystemQRCOde = async (hsId, type) =>
  fetcher.request<TDownloadQRCodeRequest, TDownloadQRCodeResponse>({
    url: `${API_DICTIONARY.AUTH}${API_DICTIONARY.SELF_SIGN_UP}${API_DICTIONARY.QR_CODE}?health_system=${hsId}&file_type=${type}`,
    method: HTTP_METHODS.GET
  })

export const getAccountPurposeOptions = async ({
  businessAccountId,
  bankAccountId
}: {
  businessAccountId: string
  bankAccountId: string
}) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${businessAccountId}/${API_DICTIONARY.BANK_ACCOUNTS}${bankAccountId}/${API_DICTIONARY.OPTIONS}${API_DICTIONARY.PURPOSE}`,
    method: HTTP_METHODS.GET
  })
